import React, { useState, useEffect } from "react";
import Modal from "@material-ui/core/Modal";
import { TextField } from "@material-ui/core";
import "../styles/CategoryList.css";
import "../styles/modalStyles.css";
import UserService from "../../services/auth/UserService";
import DomainService from "../../services/DomainService";
import FilteringTable from "./FilteringTable";
import { timeConverter, isoCountries } from "./TableHelper";

const AddUserToDomainModal = ({ open, onClose, domainName, domainId }) => {
  const [newUser, setNewUser] = useState({
    email: "",
    password: "",
  });

  const [message, setMessage] = useState("");

  const newUserToken = "n4FxJdpRadUnvdE97z02";

  //   useEffect(() => {}, []);

  const handleChange = (event) => {
    const { name, value } = event.target;
    // console.log("name: " + name, " value: " + value);
    // console.log(event.target);
    setNewUser({ ...newUser, [name]: value });
  };

  const submit = () => {
    var userWithToken = {
      email: newUser.email,
      password: newUser.password,
      newUserToken: newUserToken,
    };

    if (domainId === 7) {
      userWithToken.isEditor = true;
    }

    UserService.addNewUserToDomain(domainId, userWithToken)
      .then(() => {
        setMessage("success");
      })
      .catch((e) => {
        setMessage("error");
      });
  };

  return (
    <Modal open={open} onClose={onClose} className="add-modal">
      <div className="add-modal-content">
        <div style={{ fontSize: "1.3rem", fontWeight: "600" }}>Add User to {domainName}</div>
        <TextField
          id="outlined-basic"
          defaultValue={newUser.email}
          label="Email"
          variant="filled"
          name="email"
          onChange={handleChange}
          fullWidth
        />
        <TextField
          id="outlined-basic"
          defaultValue={newUser.password}
          label="Password"
          variant="filled"
          name="password"
          onChange={handleChange}
          fullWidth
        />
        <div
          style={{
            padding: "0.5rem",
            margin: "0.5rem",
            borderRadius: "0.3rem",
            color: "white",
            backgroundColor: "#3489eb",
            cursor: "pointer",
          }}
          onClick={submit}
        >
          Submit
        </div>
        {message}
      </div>
    </Modal>
  );
};

const DeleteUserModal = ({ open, onClose, domainId, domainName }) => {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");

  const handleChange = (e) => {
    setEmail(e.target.value);
  };

  const deleteUserToken = "n4FxJdpRadUnvdE97z02";

  const submit = () => {
    var formatted = {
      email: email,
      deleteUserToken: deleteUserToken,
    };
    UserService.deleteUserByEmailAndDomain(domainId, formatted)
      .then(() => {
        setMessage("success");
      })
      .catch((e) => {
        setMessage("error");
      });
  };

  return (
    <Modal open={open} onClose={onClose} className="add-modal">
      <div className="add-modal-content">
        <div style={{ fontSize: "1.3rem", fontWeight: "600" }}>Delete User from {domainName}</div>
        <TextField
          id="outlined-basic"
          defaultValue={email}
          label="Email"
          variant="filled"
          name="email"
          onChange={handleChange}
          fullWidth
        />
        <div
          style={{
            padding: "0.5rem",
            margin: "0.5rem",
            borderRadius: "0.3rem",
            color: "white",
            backgroundColor: "#fc425b",
            cursor: "pointer",
          }}
          onClick={submit}
        >
          Delete
        </div>
        {message}
      </div>
    </Modal>
  );
};

const UserDetailsModal = ({ open, onClose, domainId, domainName }) => {
  const [realuserCount, setRealUserCount] = useState();
  const [userData, setUserData] = useState([]);
  const [initialUserData, setInitialUserData] = useState([]);
  // const [authUsers, setAuthUsers] = useState([]);
  // const [monthlyUsers, setMonthlyUsers] = useState([]);
  // const [yearlyUsers, setYearlyUsers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [downloadableData, setDownloadableData] = useState([]);

  useEffect(() => {
    if (open && domainId) {
      console.log("get user data");
      setLoading(true);
      DomainService.getUserData(domainId)
        .then((response) => {
          setLoading(false);
          setError(false);

          formatDownloadableData(JSON.parse(JSON.stringify(response.data.users)));

          setRealUserCount(response.data.real_active_user_count);
          // console.log(response.data);

          let temp = response.data.users;
          temp.forEach((user) => {
            user.refreshId = user.id;
          });

          setUserData(temp);
          setInitialUserData(temp);
          console.log(temp);

          // setYearlyUsers(
          //   response.data.users.filter((u) => {
          //     return u.tier === "yearly";
          //   })
          // );

          // setMonthlyUsers(
          //   response.data.users.filter((u) => {
          //     return u.tier === "monthly";
          //   })
          // );

          // setAuthUsers(
          //   response.data.users.filter((u) => {
          //     return !(u.tier === "monthly" || u.tier === "yearly");
          //   })
          // );

          console.log("user data for domain: ", response.data);
        })
        .catch((e) => {
          setLoading(false);
          setError(true);
          console.log("error fetching user data: ", e);
        });
    }
  }, [domainId, open]);

  const formatDownloadableData = (data) => {
    data.forEach((user) => {
      // get rid of unnecessary data
      delete user.id;
      delete user.refreshId;

      // format the 'TRUE' and 'FALSE' of the newsletter column
      if (user.newsletter) user.newsletter = "✓";
      else user.newsletter = "";

      // make country readable
      user.country = isoCountries[user.country];

      user.activeSince = timeConverter(user.activeSince, false);
    });
    setDownloadableData(data);
  };

  return (
    <Modal open={open} onClose={onClose} className="add-modal">
      <div className="add-modal-content" id="userData">
        {" "}
        <div className="table-label">User Data from {domainName}</div>
        {!error && !loading && userData && (
          <div className="user-table">
            <FilteringTable
              initialUserData={initialUserData}
              userData={userData}
              setUserData={setUserData}
              activeUsers={realuserCount}
              downloadableData={downloadableData}
            />
          </div>
        )}
        {!error && loading && <div>Loading User Data...</div>}
        {error && <div>There was an error loading user data.</div>}
      </div>
    </Modal>
  );
};

export { AddUserToDomainModal, DeleteUserModal, UserDetailsModal };
